import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { obtenerMercaderiaFumigada } from '../../actions/listados'
import LiquidacionMercaderiaFumigadaView from '../../components/listados/LiquidacionMercaderiaFumigadaView'

function LiquidacionMercaderiaFumigada (props) {
  const { obtenerMercaderiaFumigada } = props

  useEffect(() => {
    obtenerMercaderiaFumigada(new Date(), new Date())
  }, [obtenerMercaderiaFumigada])

  const actualizarFechas = (fechaD, fechaH) => {
    obtenerMercaderiaFumigada(fechaD, fechaH)
  }

  return (
    <>
      <div className='container-entre-fechas'>
        <DatePicker
          selectRange
          disabledFuture
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>
      <LiquidacionMercaderiaFumigadaView />
    </>
  )
}

const mapActionsToProps = {
  obtenerMercaderiaFumigada
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(LiquidacionMercaderiaFumigada)
